import type { Exercise, ExerciseType } from '../types/content';

interface Presentation {
  label: string;
  category: 'speaking' | 'natural' | 'recall' | 'understanding';
  visual: 'mic' | 'rewrite' | 'cards' | 'wave' | 'connector';
}

export const presentationByType: Record<ExerciseType, Presentation> = {
  'guided-exposure': { label: 'MØT SPRÅKET', category: 'understanding', visual: 'wave' },
  recognition: { label: 'GJENKJENNING', category: 'understanding', visual: 'cards' },
  retrieval: { label: 'MINNE', category: 'recall', visual: 'cards' },
  construction: { label: 'BYGG SETNINGEN', category: 'natural', visual: 'connector' },
  reformulation: { label: 'NYANSER', category: 'natural', visual: 'rewrite' },
  listening: { label: 'LYTTING', category: 'understanding', visual: 'wave' },
  pronunciation: { label: 'UTTALE', category: 'speaking', visual: 'wave' },
  'extended-production': { label: 'MUNTLIG', category: 'speaking', visual: 'mic' },
  conversation: { label: 'SAMTALE', category: 'speaking', visual: 'mic' },
  'error-repair': { label: 'REPARASJON', category: 'natural', visual: 'rewrite' }
};

const typeTitles: Record<ExerciseType, string> = {
  'guided-exposure': 'Se språket i bruk',
  recognition: 'Velg riktig situasjon',
  retrieval: 'Hent fram uttrykket',
  construction: 'Bind tankene sammen',
  reformulation: 'Fra riktig til naturlig',
  listening: 'Lytt etter meningen',
  pronunciation: 'Lytt og prøv selv',
  'extended-production': 'Snakk uten manus',
  conversation: 'Samtaletrening',
  'error-repair': 'Rett mønsteret'
};

export function exerciseTitle(exercise: Exercise): string {
  const title = exercise.content.title;
  if (typeof title === 'string') return title;
  const lemma = exercise.content.lemma;
  if (exercise.type === 'recognition' && typeof lemma === 'string') return `Forstå «${lemma}»${exercise.content.context ? ' i kontekst' : ''}`;
  if (exercise.type === 'retrieval' && typeof lemma === 'string') return `Hent fram «${lemma}»`;
  return typeTitles[exercise.type];
}

export function exerciseDescription(exercise: Exercise): string {
  for (const field of ['instruction', 'situation', 'prompt', 'communicativeGoal', 'explanation']) {
    const value = exercise.content[field];
    if (typeof value === 'string') return value;
  }
  return 'Øv på norsk i en konkret situasjon.';
}

export function estimatedMinutes(exercise: Exercise): string {
  const minutes = Math.max(1, Math.ceil(exercise.estimatedSeconds / 60));
  return `${minutes} MIN`;
}
